import React, { useState, useEffect } from 'react';
import './TemperatureSelector.css';

// Desired-temperature stepper. `value` is the current target from /status; +/- and the input call
// `onChange` with the new target. Dimmed when not in Active mode (still usable — changing the target
// switches the backend to Active).
const TemperatureSelector = ({ value, dimmed, onChange }) => {
  const step = 0.5;
  const [input, setInput] = useState(value);

  useEffect(() => { setInput(value); }, [value]);

  return (
    <div className="temperature-selector px-3" style={{ opacity: dimmed ? 0.45 : 1 }}>
      <div className="row">
        <div className="col-2 p-0">
          <button onClick={() => onChange(value - step)}>-</button>
        </div>
        <div className="col-8 p-0">
          <input
            className="temperature-selector-input"
            type="number"
            step={step}
            value={input}
            onChange={(e) => setInput(parseFloat(e.target.value))}
            onBlur={() => { if (!Number.isNaN(input) && input !== value) onChange(input); }}
          />
        </div>
        <div className="col-2 p-0">
          <button onClick={() => onChange(value + step)}>+</button>
        </div>
      </div>
    </div>
  );
};

export default TemperatureSelector;
